export const PRODUCT_ADD_REQUEST = "PRODUCT_ADD_REQUEST";
export const PRODUCT_ADD_SUCCESS = "PRODUCT_ADD_SUCCESS";
export const PRODUCT_ADD_FAIL = "PRODUCT_ADD_FAIL";

export const PRODUCT_DETAIL_REQUEST = "PRODUCT_DETAIL_REQUEST";
export const PRODUCT_DETAIL_SUCCESS = "PRODUCT_DETAIL_SUCCESS";
export const PRODUCT_DETAIL_FAIL = "PRODUCT_DETAIL_FAIL";

export const PRODUCT_UPDATE_REQUEST = "PRODUCT_UPDATE_REQUEST";
export const PRODUCT_UPDATE_SUCCESS = "PRODUCT_UPDATE_SUCCESS";
export const PRODUCT_UPDATE_FAIL = "PRODUCT_UPDATE_FAIL";

export const PRODUCT_DELETE_REQUEST = "PRODUCT_DELETE_REQUEST";
export const PRODUCT_DELETE_SUCCESS = "PRODUCT_DELETE_SUCCESS";
export const PRODUCT_DELETE_FAIL = "PRODUCT_DELETE_FAIL";

export const PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_FAIL = "PRODUCT_LIST_FAIL";

export const PRODUCT_EXTRA_LIST_REQUEST = "PRODUCT_EXTRA_LIST_REQUEST";
export const PRODUCT_EXTRA_LIST_SUCCESS = "PRODUCT_EXTRA_LIST_SUCCESS";
export const PRODUCT_EXTRA_LIST_FAIL = "PRODUCT_EXTRA_LIST_FAIL";

export const PRODUCT_EXTRA_DELETE_REQUEST = "PRODUCT_EXTRA_DELETE_REQUEST";
export const PRODUCT_EXTRA_DELETE_SUCCESS = "PRODUCT_EXTRA_DELETE_SUCCESS";
export const PRODUCT_EXTRA_DELETE_FAIL = "PRODUCT_EXTRA_DELETE_FAIL";
export const PRODUCT_EXTRA_DELETE_RESET = "PRODUCT_EXTRA_DELETE_RESET";

export const PRODUCT_EXTRA_ADD_REQUEST = "PRODUCT_EXTRA_ADD_REQUEST";
export const PRODUCT_EXTRA_ADD_SUCCESS = "PRODUCT_EXTRA_ADD_SUCCESS";
export const PRODUCT_EXTRA_ADD_FAIL = "PRODUCT_EXTRA_ADD_FAIL";
export const PRODUCT_EXTRA_ADD_RESET = "PRODUCT_EXTRA_ADD_RESET";

export const PRODUCT_EXTRA_ADD_ITEM_REQUEST = "PRODUCT_EXTRA_ADD_ITEM_REQUEST";
export const PRODUCT_EXTRA_ADD_ITEM_SUCCESS = "PRODUCT_EXTRA_ADD_ITEM_SUCCESS";
export const PRODUCT_EXTRA_ADD_ITEM_FAIL = "PRODUCT_EXTRA_ADD_ITEM_FAIL";
export const PRODUCT_EXTRA_ADD_ITEM_RESET = "PRODUCT_EXTRA_ADD_ITEM_RESET";

export const PRODUCT_EXTRA_DELETE_ITEM_REQUEST = "PRODUCT_EXTRA_DELETE_ITEM_REQUEST";
export const PRODUCT_EXTRA_DELETE_ITEM_SUCCESS = "PRODUCT_EXTRA_DELETE_ITEM_SUCCESS";
export const PRODUCT_EXTRA_DELETE_ITEM_FAIL = "PRODUCT_EXTRA_DELETE_ITEM_FAIL";
export const PRODUCT_EXTRA_DELETE_ITEM_RESET = "PRODUCT_EXTRA_DELETE_ITEM_RESET";
